import {Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {filter, first} from "rxjs/operators";
import {HostingService} from "../../../../websites/website/hosting/hosting.service";
import {DbResponse} from "../../../interceptors/db-response";
import {
  MigrationSuccessDialogComponent
} from "../../../../websites/add-website-dialog/migration-success-dialog/migration-success-dialog.component";
import {DbModalService} from "../../../../modules/modal/modal";
import {ManualMigrationDialogComponent} from "../migration/manual-migration-dialog/manual-migration-dialog.component";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {GoogleAnalyticsService} from "../../../services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-migration-rest-api-blocked',
    templateUrl: './migration-rest-api-blocked.component.html',
    styleUrls: ['./migration-rest-api-blocked.component.scss'],
    standalone: false
})
export class MigrationRestApiBlockedComponent implements OnInit {
  @Input() websiteId: number;
  @Input() formData: any;
  public loading: boolean;

  constructor(
    private readonly _hostingService: HostingService,
    private readonly _activeModal: DbActiveModal,
    private readonly _modalService: DbModalService,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _dialogService: DialogService,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnInit() {
    this._addEventHandlers();
  }

  private _addEventHandlers(): void {
  }

  public migrate() {
    this.loading = true;
    this._hostingService.autoMigration(this.formData, this.websiteId, false)
      .pipe(
        filter((response: DbResponse) => !!response),
        first()
      )
      .subscribe((response: DbResponse) => {
        if (response.success) {}
        else if (response.response && response.response['error'].data.rest_route === 'not_available') {
          this.loading = false;
        }
        else {
          this.showManualMigrationModal();
        }
      });
  }

  public showManualMigrationModal(failed = false): void {
    this._activeModal.close();
    this._dialogService.addDialog(ManualMigrationDialogComponent, {ErrMessage: failed});
  }

  public showMigrationSuccessModal({websiteId, data}: {websiteId: number, data: any}): void {
    this._store.select(fromStore.getWebsite(Number(data.migrating_domain_id)))
      .pipe(
        first(website => !!website)
      )
      .subscribe(website => {
        const _websiteOld = website;
        const siteUrlOld = _websiteOld ? _websiteOld.site_url : '';
        const scoreOld = _websiteOld && _websiteOld.score && _websiteOld.score.originalScore && _websiteOld.score.originalScore.desktopScore;
        const mobileScoreOld = _websiteOld && _websiteOld.score && _websiteOld.score.originalScore && _websiteOld.score.originalScore.mobileScore;
        const desktopTTIOld = _websiteOld && _websiteOld.score && _websiteOld.score.originalScore && _websiteOld.score.originalScore.desktopTTI;
        const mobileTTIOld = _websiteOld && _websiteOld.score && _websiteOld.score.originalScore && _websiteOld.score.originalScore.mobileTTI;
        const oldData = {
          'websiteSiteUrl': siteUrlOld,
          'score': scoreOld,
          'desktopTTI': desktopTTIOld,
          'mobileScore': mobileScoreOld,
          'mobileTTI': mobileTTIOld,
        };
        const newData = {
          'websiteId': data.id,
          'websiteSiteUrl': data.score && data.score.url,
          'score': data.score && data.score.desktop_score,
          'desktopTTI': data.score && data.score.desktop_tti,
          'mobileScore': data.score && data.score.mobile_score,
          'mobileTTI': data.score && data.score.mobile_tti
        };

        this._activeModal.close();
        const modal = this._modalService.open(MigrationSuccessDialogComponent);
        modal.componentInstance.oldData = oldData;
        modal.componentInstance.newData = newData;
      });
  }


  public closeDialog(): void {
    this._activeModal.close();
  }

}
